/**
 * Cartão "interagir" do HUD (F81, mockup ui-b, embaixo à direita): a mão, a ação e a tecla. Sai do rótulo
 * do alvo (`#alvo`, "Bancada · E abre", "Bia caiu · segure E para levantar (12 s)"): o trecho com a tecla
 * de interagir vira a ação, o resto vira o título. Sem a tecla no rótulo, não há cartão.
 */
export interface InteractPrompt {
  /** O que está na mira ("Bancada", "Cruz de Bia"). */
  title: string;
  /** A ação, com a primeira letra maiúscula ("Abre", "Segure para reviver"). */
  action: string;
  /** A tecla (o nome da remapeada: "E", "F"). */
  key: string;
  /** Segurar a tecla (reviver, levantar). */
  hold: boolean;
}

const escape = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export function interactPrompt(label: string | undefined, key: string): InteractPrompt | undefined {
  if (!label || !key) return undefined;
  const parts = label.split(" · ");
  const k = escape(key);
  const word = new RegExp(`(^|\\s)${k}(?=\\s|$)`);
  // A ação é o último trecho com a tecla (revisão da F81): o nome na frente pode ter a letra da tecla
  // ("Zé E · E abre"); de preferência um que começa por ela ou por "segure".
  const lead = new RegExp(`^(segure\\s+)?${k}(?=\\s|$)`, "i");
  let i = parts.findLastIndex((p) => lead.test(p.trim()));
  if (i < 0) i = parts.findLastIndex((p) => word.test(p));
  if (i < 0) return undefined;
  const part = parts[i]!.trim();
  // O que vem antes da tecla num trecho que não começa por ela ("pronto: E para zarpar") é do título.
  const at = lead.test(part) ? -1 : part.search(new RegExp(`\\s${k}(?=\\s|$)`));
  const prefix = at > 0 ? part.slice(0, at).replace(/[:\s]+$/, "") : "";
  const raw = (at > 0 ? part.slice(at) : part).replace(word, "$1").replace(/\s+/g, " ").trim();
  if (!raw) return undefined;
  const title = [...parts.slice(0, i), ...(prefix ? [prefix] : []), ...parts.slice(i + 1)].join(" · ");
  return { title, action: raw.charAt(0).toUpperCase() + raw.slice(1), key, hold: /^segure\b/i.test(raw) };
}
